export default "__VITE_ASSET__46ba416a__"